import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { configuration } from "../configuration";

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: configuration.appInsightsInstrumentationKey,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
  },
});

appInsights.addTelemetryInitializer((envelope) => {
  if (!envelope.tags) {
    envelope.tags = [];
  }

  envelope.tags.push({ "ai.cloud.role": "CODE Web App" });
});

appInsights.loadAppInsights();

export { appInsights, reactPlugin };
